var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clearfix order_header border_bottom1px"},[_c('img',{staticClass:"left left_icon",attrs:{"src":require("@/assets/order/icon_order1@2x.png"),"alt":""}}),_c('div',{staticClass:"left colo087 font14 font_weight500 line_height_20 header_title"},[_vm._v(" "+_vm._s(_vm.storeDet.storeName)+" ")]),(
      _vm.storeDet.status === 13 ||
        _vm.storeDet.status === 14 ||
        _vm.storeDet.status === -10 ||
        _vm.storeDet.status === -11
    )?_c('img',{staticClass:"right right_delete",attrs:{"src":require("@/assets/mine/icon_delete@2x.png"),"alt":""},on:{"click":_vm.clickBtn}}):_vm._e(),_c('div',{staticClass:"right colo038 font12 font_weight400 line_height_20 header_status",class:{
      status_red_color:
        _vm.storeDet.status !== 13 &&
        _vm.storeDet.status !== 14 &&
        _vm.storeDet.status !== -10 &&
        _vm.storeDet.status !== -11
    },on:{"click":_vm.clickBtn}},[_vm._v(" "+_vm._s(_vm._f("statusDet")(_vm.storeDet.status))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }